import {
	SET_FORM_STATE,
	RESET_FIELDS,
	SET_SELECTED_DATABASE,
	SET_SELECTED_YEAR,
	SET_SELECTED_MONTH,
	GET_DATABASE_NAMES,
	GET_DATABASE_YEARS,
	GET_DATABASE_MONTHS,

} from '../actions/DatasetExportActions';

const initialState = {
	databases: [],
	years: [],
	months: [],
	formState: {
		isValid: false,
		values: {
			selectedDatabase: '',
			selectedYear: '',
			selectedMonth: '',
		}
	},
	touched: {},
	errors: {},

};

const datasetExportReducer = (state = initialState, action) => {
	switch (action.type) {
					case SET_FORM_STATE: {
						return {
							...state,
							formState: action.formState
						};
					}
					case RESET_FIELDS: {
						return {
							...state,
							years: [],
							months: []
						};
					}
					case SET_SELECTED_DATABASE: {
						return {
							...state,
							selectedDatabase: action.selectedDatabase
						};
					}
					case SET_SELECTED_YEAR: {
						return {
							...state,
							selectedYear: action.selectedYear
						};
					}
					case SET_SELECTED_MONTH: {
						return {
							...state,
							selectedMonth: action.selectedMonth
						};
					}
					case GET_DATABASE_NAMES: {
						return {
							...state,
							databases: action.databases
						};
					}
					case GET_DATABASE_YEARS: {
						return {
							...state,
							years: action.years
						};
					}
					case GET_DATABASE_MONTHS: {
						return {
							...state,
							months: action.months
						};
					}
					default: {
						return state;
					}
	}
};

export default datasetExportReducer;
